import React, { useState, useContext } from 'react';
import { motion } from 'framer-motion';
import { modalVariants } from '../../../utils/frame-motion-variants';
import { UserContext } from '../../../context/UserContext';
import { dismissModal } from '../../../service/modal-service';
import { SystemError } from '../../error/SystemError';
import { LoadingCover } from '../../commons/LoadingCover';
import { deleteFitnessPackage } from '../../../api/personal-trainer/personal-trainer-api';

export const DeleteFitnessListing = (props) => {
    const getListings = props.getListings
    const editlistingId = props.editlistingId

    const [ isLoading, setIsLoading ] = useState(false)
    const [ isSystemError, setIsSystemError ] = useState(false);
    const [ errorContent, setErrorContent ]  = useState({'header': "", 'body': ""});     
    
    const { userId, } = useContext(UserContext)

    const deleteListing = async() => {
        setIsLoading(true)
		try {
            await deleteFitnessPackage(userId, editlistingId)
            setIsLoading(false)
            getListings()
            dismissModal()
        } catch (error) {
            console.log(error)
            setErrorContent({'header': "Error deleting listing", 'body': "Please try again. If problem persists, contact us at support@stringssg.com"})
            setIsSystemError(true)
            setIsLoading(false)
            return
        }	
    };

  return (
      <>
        <div className="flex justify-center items-center right-0 top-0 fixed z-20 w-full h-full backdrop-blur-sm bg-black/10 overflow-y-auto">
            <motion.div className="absolute p-4 w-full max-w-2xl"
                variants={modalVariants}
                initial="initial"
                animate="animate"
                exit="exit"  
            >
                <div className="relative bg-white rounded-lg shadow space-y-5 px-6 py-6">
                    <div className="flex justify-between items-center pb-4 rounded-t border-b ">
                        <h3 className="text-lg font-semibold text-orange-600 ">
                            Delete Listing
                        </h3>
                    </div>                    
                    <div>
                        Are you sure about deleting your listing?
                    </div>        
                    <div className='flex justify-between'>
                        <button type='button' className='px-4 py-3 rounded-lg text-orange-600 shadow' onClick={() => dismissModal()}>
                            Cancel
                        </button>
                        <button type='button' className='px-4 py-3 rounded-lg text-white bg-linear-to-tr from-red-700 to-red-400 ' disabled={isLoading}
                            onClick={() => deleteListing()}
                        >
                            Delete
                        </button>
                    </div> 
                </div>
            </motion.div>
        </div>
        {isLoading &&
            <LoadingCover/>
        }
        {isSystemError && <SystemError errorContent={errorContent} setIsSystemError={setIsSystemError}/>}
      </>
  )
}
